import qs from 'qs'
import { installNewBillingConfig, flowTypes } from './forOPC'

const isDevEnv = process.env.NODE_ENV !== 'production'

const pageType = {
  OPC: 'one-page-checkout',
  PM: 'payment-management',
  UNKNOWN: 'unknown'
};

const pageTypePartens = [
  { type: pageType.OPC, urlParten: url => /\/opc\//i.test(url) },
  { type: pageType.PM, urlParten: url => /\/billing\/payment/i.test(url) },

  // default
  { type: pageType.UNKNOWN, urlParten: url => /.*/i.test(url) }
]

function getPageInfo() {
  const urlSearch = location.search
  const urlPath = location.pathname
  const pageInfo = pageTypePartens.find(item => item.urlParten(urlPath))
  const params = qs.parse(urlSearch.slice(1))
  return {
    type: pageInfo.type,
    params,
    isDevEnv
  }
}

let pageInfo = getPageInfo()

pageInfo.type === pageType.OPC && (pageInfo = installNewBillingConfig(pageInfo))

export { flowTypes, pageType }

export default pageInfo
